import { render, staticRenderFns } from "./Swoosh.vue?vue&type=template&id=4b9888b4&scoped=true"
import script from "./Swoosh.vue?vue&type=script&lang=js"
export * from "./Swoosh.vue?vue&type=script&lang=js"
import style0 from "./Swoosh.vue?vue&type=style&index=0&id=4b9888b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9888b4",
  null
  
)

export default component.exports